import React from "react";

const MultpleCard = ({ title, description, icon }) => {
  return (
    <div className="process-card">
      <div className="process-icon">
        <img src={icon} alt={title} />
      </div>
      <div className="process-title ">{title}</div>
      <div className="process-desc">{description}</div>
    </div>
  );
};
export default MultpleCard;
